import { Subject } from "@clockwise/design-system/icons";
import { TextField } from "@material-ui/core";
import React, { useCallback } from "react";

interface Props {
  description: string;
  onChange: (description: string) => void;
}

export const EventSchedulerDescriptionInput = ({ description, onChange }: Props) => {
  const onDescriptionChange = useCallback(
    (event: React.ChangeEvent<HTMLTextAreaElement>) => {
      onChange(event.target.value);
    },
    [onChange],
  );

  return (
    <div className="cw-flex cw-items-center cw-py-[10px] fs-exclude">
      <Subject className="cw-mr-[10px] cw-w-[20px] cw-mt-1 cw-self-start cw-fill-slate-standard" />
      <TextField
        placeholder="Add description"
        InputProps={{
          disableUnderline: true,
        }}
        multiline
        fullWidth
        value={description}
        onChange={onDescriptionChange}
        cw-id="event-scheduler-description-input"
      />
    </div>
  );
};
